
import {GiHamburgerMenu} from "react-icons/gi"
import {AiOutlinePlusCircle} from "react-icons/ai"
import {BiMessage} from "react-icons/bi"
import {TfiClose} from "react-icons/tfi"
import { useState , useEffect} from "react"
import { llmAPI } from "../services/llm.service"
import { Button } from "antd"
import { useLocation } from "react-router-dom"
const Chatwindow=()=>{
    const [expandSidebar,setExpandSidebar]=useState(false)
    const [question,setQuestion]=useState("")
    const location=useLocation()
    const [isLoading,setIsLoading]=useState(false)
    const [chats,setchats]=useState([
       ])

    const [creators,setCreators]=useState([{"name":"Swarnnika","email":"swarnikarajsingh@gmail.com","domain":"Swarnnika-bot", img:"https://media.licdn.com/dms/image/D5603AQE6A1ssqHKCWw/profile-displayphoto-shrink_200_200/0/1686487500917?e=1704326400&v=beta&t=3EH7Iwdqu8PZERjutyim0P7wqVKcAhjWlT860qHNGPw", _id:"1"},{  _id:"2","name":"Ankur","email":"ankur@gmail.com","domain":"Ankur-warikoo-bot","img":"https://images.assettype.com/fortuneindia/2017-06/a90f4e9f-a80e-4166-b9aa-bcacc9af1b5b/ankurwarikoo.jpg"},{  _id:"3","name":"Sadhguru","email":"sadhguru@gmail.com","domain":"sadhguru-bot",img:"https://tse4.mm.bing.net/th?id=OIP.XzHJmPgFeSZmg6HTIYPsMQHaFU&pid=Api&P=0&h=180"},{  _id:"4","name":"Nikis","email":"nikis@gmail.com","domain":"Nikis-bot",img:"https://www.nickiswift.com/img/gallery/famous-youtube-stars-who-sadly-died-far-too-young/intro-1589487557.jpg"}])
    
    useEffect(()=>{
        console.log(location, "location")
            },[location])

    async function postQuestion(){
        try{
            setchats([...chats,{question:question}])
            setQuestion("")
    
            const res=await llmAPI(question)
            const newcht=chats.filter((obj)=>obj.question!==question)
            console.log(res,'response')
            setchats([...newcht,{question:question,answer:res.response}])
           

        }
        catch(err){
            console.log(err)
        }
      

    }
    
    return <div class="absolute left-0 right-0 top-16 bottom-0 overflow-y-auto py-8 bg-gradient-to-b from-black via-[#4F4484] to-[#4F4484]  px-6 ">
       
       { !expandSidebar  && <div className=" flex py-4">
            <div onClick={()=>setExpandSidebar(true)}><GiHamburgerMenu className="text-white text-xl cursor-pointer"/></div>
        </div>
        
}
{ expandSidebar && <div   className={` px-4 absolute left-0 top-0 bottom-0 bg-[#484687] transform translate-x-0 delay-300 ${expandSidebar? "w-auto":"w-0"}`}>
    
    <div className="flex justify-between gap-2"><div className="flex gap-2 bg-slate-50 px-2 py-1 my-2 rounded-sm"><AiOutlinePlusCircle/> <p>NEW CHAT</p></div> 
    <div onClick={()=>setExpandSidebar(false)}><TfiClose className="text-white mt-3 cursor-pointer"/></div></div>
    <div className="bg-[#D9D9D9] flex gap-2 px-2">
        <BiMessage className="mt-1"/> <p>Swarnnika</p>
        </div>

</div>}

        {/* profile start */}

        <div className=" flex justify-center items-center">

<div className="my-4">

<div className=" rounded-full w-40 h-40 flex items-center justify-center">
    <img className="rounded-full w-full h-full" src="https://media.licdn.com/dms/image/D5603AQE6A1ssqHKCWw/profile-displayphoto-shrink_200_200/0/1686487500917?e=1704326400&v=beta&t=3EH7Iwdqu8PZERjutyim0P7wqVKcAhjWlT860qHNGPw" alt="dp"/>
 </div>

 <div className="text-white">Swarnnika</div>

</div>


{/* profile ends */}

           


        </div>

    {/* chats */}
<div className=" items-center justify-center flex">
    <div>
    {
        chats?.map((chat)=><div>
            {/* question */}

            <div className="flex my-4 gap-2 w-2/3 mx-auto" >
                <div className="bg-transparent   text-base border border-[#868BFF] rounded-md text-[#fff] font-poppins uppercase"> {chat.question}</div>
                <div className="w-6 h-6 rounded-full">
                <img className="rounded-full w-full h-full" src="https://media.licdn.com/dms/image/D5603AQE6A1ssqHKCWw/profile-displayphoto-shrink_200_200/0/1686487500917?e=1704326400&v=beta&t=3EH7Iwdqu8PZERjutyim0P7wqVKcAhjWlT860qHNGPw" alt="dp"/>
                </div>
            </div>
{/* answer */}
{chat?.answer && 
            <div className="flex gap-2 my-4 w-3/4 mx-auto ">
            <div className="bg-transparent   text-base border rounded-md border-[#FFFFFF] text-[#fff] font-poppins uppercase"> {chat.answer}</div>
            <div className="w-8 h-8 rounded-full">
                <img className="rounded-full w-8 h-8" src="https://media.licdn.com/dms/image/D5603AQE6A1ssqHKCWw/profile-displayphoto-shrink_200_200/0/1686487500917?e=1704326400&v=beta&t=3EH7Iwdqu8PZERjutyim0P7wqVKcAhjWlT860qHNGPw" alt="dp"/>
                </div>
            </div>
}
        </div>)
    }

    <div>

    <div className="flex my-4 gap-2 w-3/3 mx-auto  text-black" >
        <textarea value={question} onChange={(e)=>setQuestion(e.target.value)} class="w-full border py-2 px-2 rounded-sm " placeholder="Ask anything" />
        <Button disabled={!question.length>0}  onClick={postQuestion}>Ask Me</Button>
    </div>
        
    </div>

</div>
</div>
    </div>

}

export default Chatwindow